/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FeatureCategory } from '../models';
/**
 * FeatureCategoryApi - axios parameter creator
 * @export
 */
export const FeatureCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of  FeatureCategories of the sorting order including Features
         * @param {string} [boatLength] Filter FeatureCategories based on boat length
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2FeatureCategoriesGet: async (boatLength?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/domestic/v2/feature_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)

            if (boatLength !== undefined) {
                localVarQueryParameter['boat_length'] = boatLength;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureCategoryApi - functional programming interface
 * @export
 */
export const FeatureCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of  FeatureCategories of the sorting order including Features
         * @param {string} [boatLength] Filter FeatureCategories based on boat length
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2FeatureCategoriesGet(boatLength?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeatureCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2FeatureCategoriesGet(boatLength, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureCategoryApi - factory interface
 * @export
 */
export const FeatureCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureCategoryApiFp(configuration)
    return {
        /**
         * Returns a list of  FeatureCategories of the sorting order including Features
         * @param {string} [boatLength] Filter FeatureCategories based on boat length
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2FeatureCategoriesGet(boatLength?: string, options?: any): AxiosPromise<FeatureCategory> {
            return localVarFp.domesticV2FeatureCategoriesGet(boatLength, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureCategoryApi - interface
 * @export
 * @interface FeatureCategoryApi
 */
export interface FeatureCategoryApiInterface {
    /**
     * Returns a list of  FeatureCategories of the sorting order including Features
     * @param {string} [boatLength] Filter FeatureCategories based on boat length
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureCategoryApiInterface
     */
    domesticV2FeatureCategoriesGet(boatLength?: string, options?: AxiosRequestConfig): AxiosPromise<FeatureCategory>;

}

/**
 * FeatureCategoryApi - object-oriented interface
 * @export
 * @class FeatureCategoryApi
 * @extends {BaseAPI}
 */
export class FeatureCategoryApi extends BaseAPI implements FeatureCategoryApiInterface {
    /**
     * Returns a list of  FeatureCategories of the sorting order including Features
     * @param {string} [boatLength] Filter FeatureCategories based on boat length
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureCategoryApi
     */
    public domesticV2FeatureCategoriesGet(boatLength?: string, options?: AxiosRequestConfig) {
        return FeatureCategoryApiFp(this.configuration).domesticV2FeatureCategoriesGet(boatLength, options).then((request) => request(this.axios, this.basePath));
    }
}
